import ResetPassword from '@modules/account/components/reset-password';

export default function ResetPasswordPage() {
  return <ResetPassword />;
}
